/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { h } from 'preact';
import { Box, Divider, Grid, MenuItem } from '@mui/material';
import { FC, lazy } from 'preact/compat';
const TextField = lazy(() => import('@mui/material/TextField'));
import { useRef } from 'preact/hooks';
import { IEditType, ISignetInfo } from '../..';
import useGetFullHeight from '../../../../hooks/useGetFullHeight';

const currencies = [
  { value: '宋体', label: '宋体' },
  { value: 'fangsong', label: '仿宋' },
  { value: 'cursive', label: '草书' },
  { value: 'serif', label: '衬线' },
  { value: 'kai', label: '楷体' },
];

interface IProps {
  editType: IEditType;
  signetInfo: ISignetInfo;
  onChangeSignetInfo: (name: keyof ISignetInfo) => (...arg: any[]) => void;
}

const Signet: FC<IProps> = (props: IProps) => {
  const { editType, signetInfo, onChangeSignetInfo } = props;

  const formGridXs = editType === 'signet' ? 6 : 6;
  const formGridMd = editType === 'signet' ? 3 : 6;

  const signetWrapRef = useRef(null);
  const signetWrapHeight = useGetFullHeight(signetWrapRef.current, {
    clearance: 30,
  });

  return (
    <Box
      component="form"
      sx={{
        '& .MuiTextField-root': { width: '100%' },
        maxHeight: { md: signetWrapHeight },
      }}
      noValidate
      autoComplete="off"
      ref={signetWrapRef}
      style={{
        overflow: 'scroll',
      }}
    >
      <Box>
        <Divider
          textAlign="left"
          style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10 }}
        >
          整体设置
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="大小"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.size}
              onChange={(e: any) => {
                onChangeSignetInfo('size')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="右偏移量"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.offsetX}
              onChange={(e: any) => {
                onChangeSignetInfo('offsetX')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="下偏移量"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.offsetY}
              onChange={(e: any) => {
                onChangeSignetInfo('offsetY')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="旋转角度"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.rotate}
              onChange={(e: any) => {
                onChangeSignetInfo('rotate')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="边框颜色"
              size="small"
              variant="outlined"
              value={signetInfo.borderColor}
              onChange={(e: any) => {
                onChangeSignetInfo('borderColor')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="不透明度(0 - 100)"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.opacity}
              onChange={(e: any) => {
                onChangeSignetInfo('opacity')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="磨损效果(0 - 100)"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.abrasion}
              onChange={(e: any) => {
                onChangeSignetInfo('abrasion')(e?.target?.value);
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Divider
          textAlign="left"
          style={{ fontWeight: 'bold', marginTop: 20, marginBottom: 10 }}
        >
          内容
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容字体大小"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.contentSize}
              onChange={(e: any) => {
                onChangeSignetInfo('contentSize')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容字体"
              size="small"
              variant="outlined"
              select
              value={signetInfo.contentFamily}
              onChange={onChangeSignetInfo('contentFamily')}
            >
              {currencies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容字体颜色"
              size="small"
              variant="outlined"
              value={signetInfo.contentColor}
              onChange={(e: any) => {
                onChangeSignetInfo('contentColor')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="内容"
              size="small"
              variant="outlined"
              multiline
              rows={4}
              value={signetInfo.content}
              onChange={(e: any) => {
                onChangeSignetInfo('content')(e?.target?.value);
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Divider
          textAlign="left"
          style={{ fontWeight: 'bold', marginTop: 20, marginBottom: 10 }}
        >
          描述
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="描述字体大小"
              size="small"
              type="number"
              variant="outlined"
              value={signetInfo.describeSize}
              onChange={(e: any) => {
                onChangeSignetInfo('describeSize')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="描述字体"
              size="small"
              variant="outlined"
              select
              value={signetInfo.describeFamily}
              onChange={onChangeSignetInfo('describeFamily')}
            >
              {currencies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="描述字体颜色"
              size="small"
              variant="outlined"
              value={signetInfo.describeColor}
              onChange={(e: any) => {
                onChangeSignetInfo('describeColor')(e?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={formGridXs} md={formGridMd}>
            <TextField
              label="描述"
              size="small"
              variant="outlined"
              multiline
              rows={4}
              value={signetInfo.describe}
              onChange={(e: any) => {
                onChangeSignetInfo('describe')(e?.target?.value);
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Signet;
